// Switch hosts. If url contains 'hd-qa74', use `https://hd-qa74.homedepotdev.com`.
// If url contains 'hd-qa71', use `https://hd-qa71.homedepotdev.com`.
// Otherwise, use production host, `https://homedepot.com`
export const getApiHost = () => {
  if (typeof window === 'undefined') return 'https://www.homedepot.com';

  const currentHost = window.location.hostname;

  if (currentHost.includes('hd-qa74')) {
    return 'https://hd-qa74.homedepotdev.com';
  }
  if (currentHost.includes('hd-qa71')) {
    return 'https://hd-qa71.homedepotdev.com';
  }

  return 'https://www.homedepot.com';
};
